import { useState, useEffect, useContext, useRef } from 'react';

import { cmnContext } from '../../../../../../common/CmnContext';


// 講師選択
function LiveReserveSelectInstructorSelect(props: any) {
  const isPc = useContext(cmnContext).isPc;

  const setIsDispModal = props.setIsDispModal;
  const selectInst = props.selectInst;
  // 講師未選択画像
  const noSelectImg = props.noSelectImg;
  // 講師情報から画像取得
  const getInstImg = props.getInstImg;
  // 講師の趣味・スコア情報
  const getInstDetailInfo = props.getInstDetailInfo;

  const wrapDivRef = useRef<HTMLDivElement | null>(null);

  // 講師画像
  const [imgSize, setImgSize] = useState<string>('0px');
  const [selectImgSrc, setSelectImgSrc] = useState<string>(noSelectImg);
  // 趣味・スコア
  const [dispInfo, setDispInfo] = useState<string>('');


  // 講師画像サイズ
  useEffect(() => {
    if (wrapDivRef.current) {
      const wrapWidth = wrapDivRef.current.offsetWidth;
      setImgSize(isPc
        ? (wrapWidth * 0.17) + 'px'
        : (wrapWidth * 0.25) + 'px'
      );
    }
  }, [wrapDivRef]);


  // 選択講師情報
  useEffect(() => {
    if(selectInst) {
      // 画像
      const newSelectImgSrc = getInstImg(selectInst);
      setSelectImgSrc(newSelectImgSrc);
      // 趣味・スコア
      const newDispInfo = getInstDetailInfo(selectInst);
      setDispInfo(newDispInfo);

    } else {
      // 講師未選択
      setSelectImgSrc(noSelectImg);
    }
  }, [selectInst])


  
  return (
    <div
      ref={wrapDivRef}
      style={{
        display: 'flex',
        textAlign: 'left',
        alignItems: 'center',
      }}
    >

      {/* 画像 */}
      <img
        className="img-rounded img-responsive"
        style={{
          width: imgSize,
          height: imgSize,
          objectFit: 'cover',
          marginRight: '5px',
        }}
        src={selectImgSrc}
      />

      {/* 情報 */}
      <div style={{
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        padding: '0 2% 0',
      }}>
        <div>
          {selectInst ?
            <>
              <p style={{margin: 0}}>{selectInst.name} 講師</p>
              {/* 趣味・スコア */}
              {dispInfo &&
                <p style={{
                    margin: 0,
                    fontSize: '12px',
                    display: '-webkit-box',
                    WebkitLineClamp: 2, // 2行まで
                    WebkitBoxOrient: 'vertical',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                }}>{dispInfo}</p>
              }
            </>
          :
            <p style={{margin: 0}}>講師を指定しない(ランダム)</p>
          }
        </div>

        {/* 選択ボタン */}
        <div>
          <button
            type="button"
            className='btn btn-success'
            style={{
              width: '100%',
              margin: isPc? '10px 0 0' : '5px 0 0',
              padding: isPc? '10px 15px' : '5px 10px',
            }}
            onClick={() => setIsDispModal(true)}
          >
            {selectInst? '選び直す' : '講師を選ぶ' }
          </button>
        </div>

      </div>

    </div>
  );
}
  
export default LiveReserveSelectInstructorSelect;